import {
  PRIVACY_POLICY_LINK,
  PRIVACY_POLICY_LINK_ES,
  TERMS_OF_SERVICE_LINK,
  TERMS_OF_SERVICE_LINK_ES,
} from '../../../pages/Root/utils/constants.ts';

export const FOOTER_LINK_LIST = [
  { text: 'digitalTurbineTermsOfUse', link: TERMS_OF_SERVICE_LINK },
  {
    text: 'noticeAtCollectionAndPrivacyPolicy',
    link: PRIVACY_POLICY_LINK,
  },
  // TODO: Uncomment when those pages will be ready
  // { text: 'managePrivacy', link: '#' },
  // {
  //   text: 'doNotSellMyPersonalInformation',
  //   link: "#",
  // },
];

export const FOOTER_LINK_LIST_ES = [
  { text: 'digitalTurbineTermsOfUse', link: TERMS_OF_SERVICE_LINK_ES },
  {
    text: 'noticeAtCollectionAndPrivacyPolicy',
    link: PRIVACY_POLICY_LINK_ES,
  },
];

// The footer text is localized automatically via i18n; only the destination
// URLs differ per language, so we pick the right link set by language here.
export const FOOTER_LINK_LIST_BY_LANG: Record<string, typeof FOOTER_LINK_LIST> =
  {
    en: FOOTER_LINK_LIST,
    es: FOOTER_LINK_LIST_ES,
  };
